import Board from '../../components/Board';
import EventPanel from '../../components/EventPanel';
import Header from '../../components/Header';
import './styles.css';

// Declaring type of props - see "Typing Component Props" for more examples
type HomePageProps = {

}; /* use `interface` if exporting so that consumers can extend */

const HomePage = ( props: HomePageProps): JSX.Element => {
	return (
		<>
		<Header />
		<main>
      		<Board />
      		<EventPanel />
		</main>
		</>
	);
}

export default HomePage;